import React from 'react'
import styled from 'styled-components';

const ContainerFeature = styled.div`
    display: flex;
    flex-direction: row;
    color: white;
    max-width: 300px;
    margin: 10px 25px;
    justify-content: center;
    align-items: center;
`

const ContainerIcon = styled.div`
    background: white;
    border-radius: 100%;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;

    > img {
        max-width: 25px;
    }
`

const ContainerText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    margin-left: 10px;

    > h4, h5, h6{
        padding: 0;
        margin: 0;
    }

    > h5{
        font-weight: 400;
    }
    
    > h6{
        font-weight: lighter;
    }
`

interface IOwnProps{
    icon: string;
    title: string;
    subTitle?: string;
    description?: string
}

const FeatureItem: React.FunctionComponent<IOwnProps> = ({ icon, title, subTitle, description }) => {
  return (
    <ContainerFeature>
        <ContainerIcon>
            <img src={icon} alt='icon' />
        </ContainerIcon>
        <ContainerText>
            <h4>{title}</h4>
            <h5>{subTitle}</h5>
            <h6>{description}</h6>
        </ContainerText>
    </ContainerFeature>
  )
}

export default FeatureItem